import Hero from './components/Hero';
import ServicesSection from './components/ServicesSection';
import StrengthsSection from './components/StrengthsSection';
import PortfolioPreview from './components/PortfolioPreview';
import QuoteCTA from './components/QuoteCTA';
import ProductSection from './components/ProductSection';
import VideoSection from './components/VideoSection';
import NewtechSection from './components/NewtechSection';
import PhotoGallery from './components/PhotoGallery';
import NoticeBoard from './components/NoticeBoard';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Hero />
      <ServicesSection />
      <StrengthsSection />
      <PortfolioPreview />
      <QuoteCTA />
    </div>
  );
}
